import img1 from "../Assets/ImgCortometraje/IMG_8600.jpg"
import img2 from "../Assets/ImgCortometraje/IMG_8604.jpg"
import img3 from "../Assets/ImgCortometraje/IMG_8609.jpg"
import img4 from "../Assets/ImgCortometraje/IMG_8613.jpg"
import img5 from "../Assets/ImgCortometraje/IMG_8616.jpg"
import img6 from "../Assets/ImgCortometraje/IMG_8622.jpg"
import img7 from "../Assets/ImgCortometraje/IMG_8634.jpg"
import img8 from "../Assets/ImgCortometraje/IMG_8651.jpg"
import img9 from "../Assets/ImgCortometraje/IMG_8656.jpg"
import img10 from "../Assets/ImgCortometraje/IMG_8658.jpg"
import img11 from "../Assets/ImgCortometraje/IMG_8659.jpg"
import img12 from "../Assets/ImgCortometraje/IMG_8661.jpg"
import img13 from "../Assets/ImgCortometraje/IMG_8663.jpg"
import img14 from "../Assets/ImgCortometraje/IMG_8665.jpg"
import img15 from "../Assets/ImgCortometraje/IMG_8669.jpg"
import img16 from "../Assets/ImgCortometraje/IMG_8672.jpg"
import img17 from "../Assets/ImgCortometraje/IMG_8677.jpg"
import img18 from "../Assets/ImgCortometraje/IMG_8686.jpg"
import img19 from "../Assets/ImgCortometraje/IMG_8691.jpg"
import img20 from "../Assets/ImgCortometraje/IMG_8702.jpg"
import img21 from "../Assets/ImgCortometraje/IMG_8705.jpg"
import img22 from "../Assets/ImgCortometraje/IMG_8706.jpg"
import img23 from "../Assets/ImgCortometraje/IMG_8713.jpg"
import img24 from "../Assets/ImgCortometraje/IMG_8723.jpg"


export const CardCortometraje = [
    {
        Titulo: "Cortometraje",
        Texto: 'Este Cortometraje busca rescatar la figura de Guido Buffo, un personaje que dejo una huella en la historia de la ciencia y el arte en Argentina. A travéz de su vida y obra, "Luz Eterna" no solo es un relato biográfico, sino una reflexión sobre la conneción entre el arte, la ciencia y la Transcendencia del Amor. Este proyectotiene como objetivo llevar esta historia al público contemporáneo, resaltando su Legado cultural y emocional.',
        imagenes: [
            img1,img2,img3,img4,img5,img6,img7,img8,img9,img10,
            img11,img12,img13,img14,img15,img16,img17,img18,img19,img20,
            img21,img22,img23,img24
        ]
    }
]